import { CustomIconProps } from './art';

export const PhysicalIcon = ({ fill }: CustomIconProps): JSX.Element => (
  <svg width="29" height="27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5 7.313c.721 0 1.412-.267 1.922-.742s.797-1.118.797-1.79c0-.671-.287-1.315-.797-1.79A2.824 2.824 0 0 0 14.5 2.25c-.721 0-1.413.267-1.922.741a2.446 2.446 0 0 0-.797 1.79c0 .672.287 1.315.796 1.79.51.475 1.202.742 1.923.742Zm8.41 1.372c.09.286.053.594-.1.856a1.196 1.196 0 0 1-.722.539c-1.435.39-2.732.683-3.963.878v12.667c0 .29-.12.569-.334.778a1.25 1.25 0 0 1-.82.347 1.265 1.265 0 0 1-.85-.276 1.1 1.1 0 0 1-.408-.747l-.604-6.188a1.048 1.048 0 0 1-.005-.102h-1.208c0 .034-.002.069-.005.102l-.604 6.188a1.101 1.101 0 0 1-.409.747c-.234.19-.539.29-.85.276a1.25 1.25 0 0 1-.819-.347 1.085 1.085 0 0 1-.334-.778V10.937c-1.228-.197-2.52-.484-3.948-.853a1.245 1.245 0 0 1-.426-.195 1.153 1.153 0 0 1-.312-.333 1.05 1.05 0 0 1-.116-.86c.043-.143.116-.277.215-.394a1.19 1.19 0 0 1 .36-.287 1.272 1.272 0 0 1 .925-.099c2.784.719 4.876 1.076 6.932 1.084 2.052.008 4.139-.33 6.907-1.08.307-.084.638-.05.919.094.28.143.49.385.579.671Z"
      fill={fill ? fill : 'url(#a)'}
    />
    <defs>
      <linearGradient
        id="a"
        x1="6.405"
        y1="11.09"
        x2="23.675"
        y2="11.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#259BE9" />
        <stop offset="1" stopColor="#AFDAF7" />
      </linearGradient>
    </defs>
  </svg>
);
